export function getUrlEnvironment(){
    return 'https://www.impeltechnology.com/';
}



// WEBPACK FOOTER //
// /Users/clgingeniero/Documents/Proyectos/Impel/acertar/src/app/shared/environment.ts